import React from "react";
import { SuggestionObject } from "app/frame/Searchbar/hooks";

interface Props {
    suggests: SuggestionObject[];
    showList: boolean;
}

export const Autosuggests = ({ suggests, showList }: Props) => {
    const classname = showList && suggests.length ? "show" : "";
    return (
        <nav className={classname}>
            {suggests.map(suggestion => (
                <a
                    key={suggestion.url}
                    title={suggestion.title}
                    href={suggestion.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    dangerouslySetInnerHTML={{ __html: suggestion.htmlTitle }}
                />
            ))}
        </nav>
    );
};
